// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Division from "../../components/Division"
import Card from "../../components/Card"
import LabeledValue from "../../components/LabeledValue"
import { withRouter } from "react-router-dom"
import * as strings from "../../strings"
import Avatar from "react-toolbox/lib/avatar/Avatar"
import Chip from "react-toolbox/lib/chip/Chip"

class ExecutionDetails extends Component {
  props: {
    onChange: () => any,

    execution: any,
    mainDebtor: any,
    history: any,
  }

  handleChange = name => value => this.props.onChange && this.props.onChange( {
    ...this.props.execution,
    [ name ]: value,
  } )

  render () {
    const { execution, mainDebtor } = this.props
    return (
      <div className={style.root}>
        <div className={style.row}>
          <Card decor style={{ flex: "6" }}>
            <div className={style.leftIslandInfo}>
              <Division title={strings.generalStrings.information.toUpperCase()}/>
              <div className={style.leftIslandBody}>
                <div className={style.wrapper}>
                  <LabeledValue big label={strings.generalStrings.debtor}>
                    {mainDebtor.contact.name}
                  </LabeledValue>
                  <LabeledValue big label={strings.generalStrings.debtorNif}>
                    {mainDebtor.contact.nif}
                  </LabeledValue>
                  <div className={style.chipWrapper}>
                    <Chip onClick={() => this.props.history.push( "/debt/" + execution.idDebt )} >
                      <Avatar style={{ backgroundColor: "#2196f3" }} icon="folder"/>
                      <span>{strings.generalStrings.watchProcess}</span>
                    </Chip>
                  </div>
                  <LabeledValue big label={strings.generalStrings.client}>
                    {execution.debt.client.contact.name}
                  </LabeledValue>
                  <LabeledValue big label={strings.generalStrings.clientNif}>
                    {execution.debt.client.contact.nif}
                  </LabeledValue>
                  <LabeledValue big label={strings.paymentAgreements.executionNumber}>
                    {execution.executionNumber}
                  </LabeledValue>
                </div>
              </div>
              <Division title={strings.paymentAgreements.court}/>
              <div className={style.secondWrapper}>
                <LabeledValue big label={strings.generalStrings.name} rootClassName={style.one}>
                  {execution.court.name}
                </LabeledValue>
                <LabeledValue big label={strings.generalStrings.id}>
                  {execution.court.id}
                </LabeledValue>
                <LabeledValue big label={strings.paymentAgreements.section}>
                  {execution.section}
                </LabeledValue>
                <LabeledValue big label={strings.paymentAgreements.service}>
                  {execution.service}
                </LabeledValue>
              </div>
            </div>
          </Card>
        </div>
      </div>

    )
  }
}

export default withRouter( ExecutionDetails )



// WEBPACK FOOTER //
// ./src/components/ExecutionDetails/index.jsx